import Workflow from "../../../../ui/src/assets/dashboard/workflow.png"
import Reporting from "../../../../ui/src/assets/dashboard/reporting.png"
import RemoteAccess from "../../../../ui/src/assets/dashboard/remoteAccess.png"
import Referal from "../../../../ui/src/assets/dashboard/referal.png"
import CloudStorage from "../../../../ui/src/assets/dashboard/cloudStorage.png"
import MoneySave from "../../../../ui/src/assets/dashboard/moneySave.png"

// steps images
import Events from "../../../../ui/src/assets/dashboard/events.png"
import ProcessImage from "../../../../ui/src/assets/dashboard/processing.png"
import ViewerImage from "../../../../ui/src/assets/dashboard/viewer.png"



export const dashboardConfig = [
    {
        title: "Workflow Management",
        imageSrc: Workflow,
        description: "Optimize your radiology workflow with automated scheduling, protocol management, and real-time status tracking, covering everything from patient scheduling and image acquisition to reporting and follow-up"
    },
    {
        title: "Reporting and Dictation",
        imageSrc: Reporting,
        description: "A powerful and adaptable reporting engine, crafted to optimize your workflow and seamlessly integrate AI-powered dictation for a more efficient reporting process."
    },
    {
        title: "Accessibility and Collaboration",
        imageSrc: RemoteAccess,
        description: "Access medical images and patient data from anywhere, facilitating seamless remote work and collaboration for healthcare professionals."
    },
    {
        title: "Reporting and Communication",
        imageSrc: Referal,
        description: "Empower your practice with a cutting-edge reporting, voice recognition, and structured reporting to effortlessly share reports and images with referring physicians and healthcare professionals."
    },
    {
        title: "Cloud-Based Access and Storage",
        imageSrc: CloudStorage,
        description: "Secure, scalable storage and remote access designed for radiologists—empowering telemedicine and ensuring seamless business continuity with rock-solid backup and disaster recovery solutions."
    },
    {
        title: "Cost Efficiency",
        imageSrc: MoneySave,
        description: "Cut down on expensive hardware and technology with budget friendly solution, by significantly reducing capital expenditures without maintenance overheads and operational costs."
    },
];

export const stepsConfig = [
    {
        title: "Step 1: Order and Scheduling",
        description: "Effortlessly streamline diagnostic imaging with seamless order placement and smart scheduling, ensuring patients receive timely and precise imaging services.",
        imageSrc: Events
    },
    {
        title: "Step 2: Imaging Procedure",
        description: "Capture detailed insights into patient health with advanced imaging procedures, seamlessly integrated with PACS for instant access to images and streamlined diagnoses, leading to more effective treatment plans.",
        imageSrc: ProcessImage
    },
    {
        title: "Step 3: Interpretation and Reporting",
        description: "Analyzing diagnostic images, deliver precise imaging interpretations and comprehensive reports to guide confident patient care and treatment decisions.",
        imageSrc: ViewerImage
    }
]
